import * as React from 'react';

import { CustomersContext } from '@funnels/contexts';
import { CustomerData } from '@funnels/types';

interface CustomersProviderProps {
  customers: CustomerData[];
  children: React.ReactNode;
}

function CustomersProvider(props: CustomersProviderProps) {
  // because of useCustomer or useHydrate can only get current customer so just reuse customers and pass down to children
  return <CustomersContext.Provider value={props.customers}>{props.children}</CustomersContext.Provider>;
}

export default CustomersProvider;
